class UoefFront extends UoefContext {
  init() {
    super.init();
    this.modelName = 'front';
  }
}

window.uoefFront = new UoefFront;
